<template>
  <div style="position: relative">
    <div
      id="tags-view-container"
      class="tags-view-container"
      :style="{
        padding: isShowArrow ? '0 26px;' : '0',
        boxSizing: 'borderBox',
      }"
    >
      <i
        v-if="isShowArrow"
        class="el-icon-caret-left"
        style="
          display: flex;
          align-items: center;
          position: absolute;
          left: 0;
          top: 0;
          bottom: 0;
          margin: auto;
          padding: 0 5px;
          background: #fff;
          z-index: 999;
        "
        :style="{
          cursor: leftIconDisabled ? 'pointer' : 'no-drop',
          color: leftIconDisabled ? '#333' : '#ddd',
        }"
        @click="scrollLeftFn"
      />
      <scroll-pane
        ref="scrollPane"
        class="tags-view-wrapper"
        @scroll="handleScroll"
      >
        <draggable
          :list="tabList"
          v-bind="$attrs"
          class="board-column-content"
          :set-data="setData"
        >
          <router-link
            v-for="(tag, index) in tabList"
            ref="tag"
            :key="tag.path"
            :class="isActive(tag) ? 'active' : ''"
            :to="{ path: tag.path, query: tag.query, fullPath: tag.fullPath }"
            tag="span"
            class="tags-view-item"
            @click.middle.native="
              !isAffix(tag) ? closeSelectedTag(tag, index) : ''
            "
            @contextmenu.prevent.native="openMenu(tag, $event, index)"
          >
            {{ tag.title }}
            <span
              v-if="!isAffix(tag)"
              class="el-icon-close"
              @click.prevent.stop="closeSelectedTag(tag, index)"
            />
          </router-link>
        </draggable>
      </scroll-pane>
      <i
        v-if="isShowArrow"
        class="el-icon-caret-right"
        style="
          display: flex;
          align-items: center;
          position: absolute;
          right: 0;
          top: 0;
          bottom: 0;
          margin: auto;
          padding: 0 5px;
          background: #fff;
          z-index: 999;
        "
        :style="{
          cursor: rightIconDisabled ? 'pointer' : 'no-drop',
          color: rightIconDisabled ? '#333' : '#ddd',
        }"
        @click="scrollRightFn"
      />
    </div>
    <ul
      v-show="visible"
      :style="{ left: left + 'px', top: top + 'px' }"
      class="contextmenu"
    >
      <!--      <li @click="refreshSelectedTag(selectedTag)">-->
      <!--        刷新-->
      <!--      </li>-->
      <li
        v-if="!isAffix(selectedTag)"
        @click="closeSelectedTag(selectedTag, selectedTagIndex)"
      >
        关闭
      </li>
      <li @click="closeOthersTags">
        关闭其他标签
      </li>
      <li @click="closeAllTags(selectedTag)">
        关闭全部
      </li>
    </ul>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import ScrollPane from "./ScrollPane";
import path from "path";

export default {
  components: { ScrollPane, draggable },
  data() {
    return {
      visible: false,
      top: 0,
      left: 0,
      selectedTag: {},
      selectedTagIndex: -1,
      affixTags: [],
      isShowArrow: false,
      leftIconDisabled: true,
      rightIconDisabled: true,
      tabList: [],
    };
  },
  computed: {
    visitedViews() {
      this.isShowArrowFn();
      return this.$store.state.tagsView.visitedViews;
    },
    routes() {
      this.btnDisabledFn();
      return this.$store.state.permission.routes;
    },
  },
  watch: {
    visitedViews(val) {
      this.tabList = val;
    },
    $route() {
      this.addTags();
      this.moveToCurrentTag();
    },
    visible(value) {
      if (value) {
        document.body.addEventListener("click", this.closeMenu);
      } else {
        document.body.removeEventListener("click", this.closeMenu);
      }
    },
  },
  mounted() {
    this.tabList = this.visitedViews;
    this.initTags();
    this.addTags();
  },
  methods: {
    setData(dataTransfer) {
      // to avoid Firefox bug
      // Detail see : https://github.com/RubaXa/Sortable/issues/1012
      dataTransfer.setData("Text", "");
    },
    isShowArrowFn() {
      if (
        document.querySelector(".tags-view-wrapper") &&
        document.querySelector(".tags-view-wrapper .el-scrollbar__wrap")
      ) {
        this.isShowArrow =
          document.querySelector(".tags-view-wrapper").scrollWidth <
          document.querySelector(".tags-view-wrapper .el-scrollbar__wrap")
            .scrollWidth;
      }
      this.btnDisabledFn();
    },
    btnDisabledFn() {
      if (
        document.querySelector(".tags-view-wrapper") &&
        document.querySelector(".tags-view-wrapper .el-scrollbar__wrap")
      ) {
        let scrollLeft = document.querySelector(
          ".tags-view-wrapper .el-scrollbar__wrap"
        ).scrollLeft;
        let offsetWidth = document.querySelector(
          ".tags-view-wrapper .el-scrollbar__wrap"
        ).offsetWidth;
        let scrollWidth = document.querySelector(
          ".tags-view-wrapper .el-scrollbar__wrap"
        ).scrollWidth;
        this.leftIconDisabled = scrollLeft == 0 ? false : true;
        this.rightIconDisabled =
          scrollLeft + offsetWidth >= scrollWidth ? false : true;
      }
    },
    scrollLeftFn() {
      let scrollLeft = document.querySelector(
        ".tags-view-wrapper .el-scrollbar__wrap"
      ).scrollLeft;
      if (scrollLeft > 0) {
        document
          .querySelector(".tags-view-wrapper .el-scrollbar__wrap")
          .scrollTo(scrollLeft - 50 > 0 ? scrollLeft - 50 : 0, 0);
      }
      this.btnDisabledFn();
    },
    scrollRightFn() {
      let scrollLeft = document.querySelector(
        ".tags-view-wrapper .el-scrollbar__wrap"
      ).scrollLeft;
      let offsetWidth = document.querySelector(
        ".tags-view-wrapper .el-scrollbar__wrap"
      ).offsetWidth;
      let scrollWidth = document.querySelector(
        ".tags-view-wrapper .el-scrollbar__wrap"
      ).scrollWidth;
      if (offsetWidth + scrollLeft < scrollWidth) {
        document
          .querySelector(".tags-view-wrapper .el-scrollbar__wrap")
          .scrollTo(
            scrollLeft + 50 > scrollWidth ? scrollWidth : scrollLeft + 50,
            0
          );
      }
      this.btnDisabledFn();
    },
    isActive(route) {
      return route.path === this.$route.path;
    },
    isAffix(tag) {
      return tag.meta && tag.meta.affix;
    },
    filterAffixTags(routes, basePath = "/") {
      let tags = [];
      routes.forEach((route) => {
        if (route.meta && route.meta.affix) {
          const tagPath = path.resolve(basePath, route.path);
          tags.push({
            fullPath: tagPath,
            path: tagPath,
            name: route.name,
            meta: { ...route.meta },
          });
        }
        if (route.children) {
          const tempTags = this.filterAffixTags(route.children, route.path);
          if (tempTags.length >= 1) {
            tags = [...tags, ...tempTags];
          }
        }
      });
      return tags;
    },
    initTags() {
      const affixTags = (this.affixTags = this.filterAffixTags(this.routes));
      // eslint-disable-next-line no-unused-vars
      for (let tag of affixTags) {
        // Must have tag name
        if (tag.name) {
          this.$store.dispatch("tagsView/addVisitedView", tag);
        }
      }
    },
    addTags() {
      const { name } = this.$route;
      console.log(this.$route);
      if (name) {
        this.$store.dispatch("tagsView/addView", this.$route);
      }
      return false;
    },
    moveToCurrentTag() {
      const tags = this.$refs.tag;
      this.$nextTick(() => {
        // eslint-disable-next-line no-unused-vars
        for (let tag of tags) {
          if (tag.to.path === this.$route.path) {
            this.$refs.scrollPane.moveToTarget(tag);
            // when query is different then update
            if (tag.to.fullPath !== this.$route.fullPath) {
              this.$store.dispatch("tagsView/updateVisitedView", this.$route);
            }
            break;
          }
        }
      });
    },
    refreshSelectedTag(view) {
      this.$store.dispatch("tagsView/delCachedView", view).then(() => {
        const { fullPath } = view;
        this.$nextTick(() => {
          this.$router.replace({
            path: fullPath,
          });
        });
      });
    },
    closeSelectedTag(view, index) {
      this.$store
        .dispatch("tagsView/delView", view)
        .then(({ visitedViews }) => {
          if (this.isActive(view)) {
            this.toLastView(visitedViews, view, index);
          }
        });
    },
    closeOthersTags() {
      this.$router.push(this.selectedTag);
      this.$store
        .dispatch("tagsView/delOthersViews", this.selectedTag)
        .then(() => {
          this.moveToCurrentTag();
        });
    },
    closeAllTags(view) {
      this.$store.dispatch("tagsView/delAllViews").then(({ visitedViews }) => {
        if (this.affixTags.some((tag) => tag.path === view.path)) {
          return;
        }
        this.toLastView(visitedViews, view);
      });
    },
    // visitedViews 标签列表 view 当前操作标签  index跳转标签标签
    toLastView(visitedViews, view, index) {
      let latestView = visitedViews.slice(-1)[0];
      if (index > -1) {
        latestView = index - 1 > 0 ? visitedViews[index - 1] : visitedViews[0];
      }
      if (latestView) {
        this.$router.push(latestView.fullPath);
      } else {
        // now the default is to redirect to the home page if there is no tags-view,
        // you can adjust it according to your needs.
        if (view.name === "Dashboard") {
          // to reload home page
          this.$router.replace({ path: "/redirect" + view.fullPath });
        } else {
          this.$router.push("/");
        }
      }
    },
    openMenu(tag, e, index) {
      const menuMinWidth = 105;
      const offsetLeft = this.$el.getBoundingClientRect().left; // container margin left
      const offsetWidth = this.$el.offsetWidth; // container width
      const maxLeft = offsetWidth - menuMinWidth; // left boundary
      const left = e.clientX - offsetLeft + 15; // 15: margin right

      if (left > maxLeft) {
        this.left = maxLeft;
      } else {
        this.left = left;
      }

      this.top = 20;
      this.visible = true;
      this.selectedTag = tag;
      this.selectedTagIndex = index;
    },
    closeMenu() {
      this.visible = false;
    },
    handleScroll() {
      this.closeMenu();
    },
  },
};
</script>

<style lang="scss" scoped>
.tags-view-container {
  height: 34px;
  width: 100%;
  background: #fff;
  border-bottom: 1px solid #d8dce5;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 0 3px 0 rgba(0, 0, 0, 0.04);
  position: relative;
  overflow: hidden;
  .tags-view-wrapper {
    .tags-view-item {
      display: inline-block;
      position: relative;
      cursor: pointer;
      height: 26px;
      line-height: 26px;
      border: 1px solid #d8dce5;
      color: #495060;
      background: #fff;
      padding: 0 8px;
      font-size: 12px;
      margin-left: 5px;
      margin-top: 4px;
      &:first-of-type {
        margin-left: 15px;
      }
      &:last-of-type {
        margin-right: 15px;
      }
      &.active {
        background-color: #f0383e;
        color: #fff;
        border-color: #af2125;
        &::before {
          content: "";
          background: #fff;
          display: inline-block;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          position: relative;
          margin-right: 2px;
        }
      }
    }
  }
}
.contextmenu {
  margin: 0;
  background: #fff;
  z-index: 3000;
  position: absolute;
  list-style-type: none;
  padding: 5px 0;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 400;
  color: #333;
  box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
  li {
    margin: 0;
    padding: 7px 16px;
    cursor: pointer;
    &:hover {
      background: #eee;
    }
  }
}
</style>

<style lang="scss">
//reset element css of el-icon-close
.tags-view-wrapper {
  .tags-view-item {
    .el-icon-close {
      width: 16px;
      height: 16px;
      vertical-align: 2px;
      border-radius: 50%;
      text-align: center;
      transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
      transform-origin: 100% 50%;
      &:before {
        transform: scale(0.6);
        display: inline-block;
        vertical-align: -3px;
      }
      &:hover {
        background-color: #b4bccc;
        color: #fff;
      }
    }
  }
}
</style>
